import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { CopyToClipboardButtonProps } from './types';

const CopyToClipboardButton: React.FC<CopyToClipboardButtonProps> = ({ textToCopy, buttonText, successText }) => {
  const [copied, setCopied] = useState(false);

  const handleCopyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(textToCopy);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      console.error('Failed to copy:', error);
    }
  };

  return (
    <>
      <Button variant="secondary" size="sm" onClick={handleCopyToClipboard} disabled={copied}>
        {copied ? successText : buttonText}
      </Button>
    </>
  );
};

export default CopyToClipboardButton;
